import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { useState } from 'react';
import Dialog1 from './components/Dialog1';
import Dialog2 from './components/Dialog2';
import Dialog3 from './components/Dialog3';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.SectionJ');

    const list = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753422597566/pc_1.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1753422597350/h5_1.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1753422598337/pad_1.png',
            title: t('item1'),
            span: true,
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753422599071/pc_2.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1753422599233/h5_2.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1753422766098/pad_2.png',
            title: t('item2'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753422598874/pc_3.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1753422598557/h5_3.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1753422766196/pad_3.png',
            title: t('item3'),
        },
    ];

    const [dialog1, setDialog1] = useState(false);
    const [dialog2, setDialog2] = useState(false);
    const [dialog3, setDialog3] = useState(false);
    const handleOpenDialog = (idx: number) => {
        switch (idx) {
            case 0:
                setDialog1(true);
                break;
            case 1:
                setDialog2(true);
                break;
            case 2:
                setDialog3(true);
                break;
            default:
                return;
        }
    };
    return (
        <div className={`section-bg-black ${styles.comp}`} id="SectionJ">
            <EcoSpace />
            <EcoSectionCommon label={t('label')} title={t('title')} theme="white" />
            <EcoSpaceSmall />
            <div className="container">
                {list.map((item, idx) => (
                    <div className={`item ${item.span ? 'span-2' : ''}`} key={idx}>
                        <EcoImg pc={item.pc} pad={item.pad} h5={item.h5} />
                        <span className="item-title">{item.title}</span>
                        <img
                            className="dialog-icon"
                            onClick={() => handleOpenDialog(idx)}
                            src="https://websiteoss.ecoflow.com/upload/image/1740649201644/dialog-icon.png"
                            alt=""
                            draggable="false"
                        />
                    </div>
                ))}
            </div>
            <EcoSpace />
            <Dialog1 show={dialog1} onClose={() => setDialog1(false)} />
            <Dialog2 show={dialog2} onClose={() => setDialog2(false)} />
            <Dialog3 show={dialog3} onClose={() => setDialog3(false)} />
        </div>
    );
}
